// Cart links handler.

const addProductToCart = async (items) => {
	const formData = {
		items: items,
	};
	const response = await fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	});

	if (!response.ok) {
		throw new Error('Failed to add product to cart');
	}
	return await response.json();
};

const setLoading = () => {
	// cart__loading-text
	// cart__empty-text
	const cartEmptyText = document.querySelector('.cart__empty-text');
	const cartLoadingText = document.querySelector('.cart__loading-text');
	cartEmptyText.style.display = 'none';
	cartLoadingText.style.display = 'block';
};

const checkCartItemsAndFooter = () => {
	// If we have an update but the rerendering failed. We reload the cart
	const cartItems = document.getElementById('main-cart-items');
	const cartFooter = document.getElementById('main-cart-footer');

	// fetch the cart again
	if (cartItems.classList.contains('is-empty') || cartFooter.classList.contains('is-empty')) {
		// check if the cart is empty
		console.log('Cart is empty fetche cart');
		fetch(`${Shopify.routes.root}cart.js`)
			.then((response) => response.json())
			.then((cart) => {
				if (cart.item_count > 0) {
					window.location.reload();
				}
			})
			.catch((e) => {
				console.error(e);
			});
	}
};

const hasBorlabsCookie = () => {
	return document.cookie.split(';').some((item) => item.trim().startsWith('borlabs-cookie='));
};

const addPendingCartItems = (items) => {
	setLoading();
	setTimeout(() => {
		addProductToCart(items)
			.then((response) => {
				console.log('Product added to cart', response);
				// Fetch full cart to get discounted prices, then publish custom tracking event
				fetch(`${Shopify.routes.root}cart.js`)
					.then((res) => res.json())
					.then((cart) => {
						if (Shopify?.analytics) {
							const changedVariantId = String(items[0]?.id);
							const changedItem = cart.items.find((i) => String(i.variant_id) === changedVariantId);
							const addedQty = parseInt(items[0]?.quantity || 1, 10);
							const previousQuantity = (changedItem?.quantity ?? addedQty) - addedQty;
							const unitPriceCents = changedItem?.price ?? 0;
							Shopify.analytics.publish('custom:cart_updated', {
								cart,
								changedVariantId,
								itemTitle: null, // resolved via changedVariantId from cart.items
								previousQuantity,
								unitPriceCents,
							});
						}
					})
					.catch((err) => console.error('Failed to fetch cart for tracking', err));
				setTimeout(() => {
					document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
				}, 10);
				setTimeout(() => {
					// fallback if the cart is not rerendered
					checkCartItemsAndFooter();
				}, 3500);
			})
			.catch((error) => {
				console.error('Failed to add product to cart', error);
			});
	}, 500);
};

// Fired by consent-handler when Shopify consent already matches Borlabs (no reload will happen)
document.addEventListener('consent:already-synced', () => {
	const pendingItemsJSON = sessionStorage.getItem('pendingCartItems');
	if (pendingItemsJSON) {
		sessionStorage.removeItem('pendingCartItems');
		console.log('Consent already synced, adding pending cart items directly');
		addPendingCartItems(JSON.parse(pendingItemsJSON));
	}
});

document.addEventListener('DOMContentLoaded', () => {
	const URLIdentifier = 'cart';
	console.log('Loadet now check the params ', window.location.href);
	// check if the URL contains the storefront=true identifier
	const params = new URLSearchParams(window.location.search);

	// After a consent reload, pick up any cart items saved before the reload
	const pendingItemsJSON = sessionStorage.getItem('pendingCartItems');
	if (pendingItemsJSON) {
		sessionStorage.removeItem('pendingCartItems');
		console.log('Adding pending cart items after consent reload');
		addPendingCartItems(JSON.parse(pendingItemsJSON));
	}

	if (hasBorlabsCookie()) {
		console.log('Borlabs cookie found, dispatching consent:params event');
		document.dispatchEvent(new CustomEvent('consent:params', { bubbles: true, detail: { params } }));
	} else {
		// No borlabs cookie found, show the consent banner
		console.log('No borlabs cookie found, showing consent banner');
		document.querySelector('body').classList.remove('hide-banner');
	}

	if (window.location.href.includes(URLIdentifier) && params.has('ids')) {
		const ids = params.get('ids').split(',');
		console.log(ids);
		const items = ids.map((variantElement) => {
			const [id, quantity] = variantElement.split(':');
			return { id, quantity };
		});

		// Strip URL immediately so any reload never re-triggers the add
		window.history.replaceState({}, document.title, window.location.pathname);

		if (sessionStorage.getItem('consentReloadedOnce') === '1') {
			// Consent already synced this session — no reload expected, add directly
			console.log('Consent already synced this session, adding to cart directly');
			addPendingCartItems(items);
		} else {
			// Consent reload is expected — save items to be added after the reload.
			// If consent already matches borlabs (no reload), consent:already-synced will handle it.
			console.log('Saving cart items for after consent reload');
			sessionStorage.setItem('pendingCartItems', JSON.stringify(items));
		}
	}
});
